
import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { FaUserAlt, FaEdit, FaSignOutAlt, FaCog, FaBell } from "react-icons/fa";
import { useNavigate } from "react-router";
import { useContext } from "react";
import { CommonContext } from "../../App";
// Import useAuth
import toast from "react-hot-toast";
import { useAuth } from "../Login/AuthContext";
import LoadingSpinner from "../CommonComponent/loadingSpiner/LoadingSpinner";
import { FaLanguage } from "react-icons/fa6";
import { IoIosArrowDown } from "react-icons/io";
import { IoMdPersonAdd } from "react-icons/io";
import i18n from "../../i18n";
import { useTranslation } from "react-i18next";
import CancelButton from "../CommonComponent/Button/CancelButton";
import SaveButton from "../CommonComponent/Button/SaveButton";
import { FaChevronDown } from "react-icons/fa";
import DateFilter from "../CommonComponent/Dropdown/DateFilter";
import api from "../../services/api";
import { IoIosWarning } from "react-icons/io";
export default function Navbar({dateFilterSingle,defaultDateRange,checkDate=false,heading}) {

 
  const [totalCash, setTotalCash] = useState(0);
  const [totalBank, setTotalBank] = useState(0);
  const [openUserDropdown, setOpenUserDropdown] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openLogoutModal, setOpenLogoutModal] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const { userData, setUserData } = useContext(CommonContext);
  const { logout } = useAuth();
  const navigate = useNavigate();
  const { branchId ,setBranchId, dateRange,setDateRange,branchExpireMSG } = useContext(CommonContext);
  const [showLanguageMenu, setShowLanguageMenu] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState("en");
  const stored = JSON.parse(localStorage.getItem("DATE_FILTER_STATE"));
  const [startDate,setStartDate]=useState(dateRange.startDate)
  const [endDate,setEndDate]=useState(dateRange.endDate)
    const nav=checkDate?endDate:startDate
  // console.log("check date in navbar", checkDate,nav)
  // const { cash, bank } = useContext(balenceContext)
  useEffect(() => {
  if ( defaultDateRange?.startDate && defaultDateRange?.endDate) {
    setStartDate(defaultDateRange.startDate);
    setEndDate(defaultDateRange.endDate);

    // Context bhi update ho jaye
    setDateRange({
      startDate: defaultDateRange.startDate,
      endDate: defaultDateRange.endDate,
    });
  }
}, [defaultDateRange]);
//   useEffect(() => {
//     setDateRange({
//       startDate: dateRange.startDate,
//       endDate: dateRange.endDate,
//     });
 
// }, [dateRange]);

 const [shake, setShake] = useState(false);
  const [user, setUser] = useState({
    id: "",
    name: "",
    email: "",
    role: "",
    image: "https://via.placeholder.com/50",
  });
  const { t, i18n } = useTranslation();
  const [editForm, setEditForm] = useState(user);
  const dropdownRef = useRef(null);

  // Fetch ledger summary
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await api.get(
          `ledgers/get-trial-summary?startDate=${startDate}&endDate=${endDate}?branchId=${branchId}`
        );
        if (res.data.success) {
          const allData = res.data.data;

          const cashRecords = allData.filter(
            (item) => item.subGroupName === "cash-in-hand"
          );
          const totalCashReceived = cashRecords.reduce(
            (sum, item) => sum + Number(item.totalReceived || 0),
            0
          );
          const totalCashPaid = cashRecords.reduce(
            (sum, item) => sum + Number(item.totalPaid || 0),
            0
          );

          const bankRecords = allData.filter(
            (item) => item.subGroupName === "bank"
          );
          const totalBankReceived = bankRecords.reduce(
            (sum, item) => sum + Number(item.totalReceived || 0),
            0
          );
          const totalBankPaid = bankRecords.reduce(
            (sum, item) => sum + Number(item.totalPaid || 0),
            0
          );

          setTotalCash(totalCashReceived - totalCashPaid);
          setTotalBank(totalBankReceived - totalBankPaid);
        }
      } catch (err) {
        console.error("Error fetching ledger summary:", err);
      }
    };
    if(branchId && startDate && endDate){
      fetchData();
    }
  }, []);

 useEffect(() => {
  const savedLang = localStorage.getItem("selectedLanguage") || "en";
  setSelectedLanguage(savedLang);
  i18n.changeLanguage(savedLang);
}, [i18n]);

useEffect(() => {

  localStorage.setItem("selectedLanguage", selectedLanguage);
  i18n.changeLanguage(selectedLanguage);
}, [selectedLanguage, i18n]);

  useEffect(() => {
    const manager = userData?.user;

    if (manager) {
      try {
        const managerData = typeof manager === "string" ? JSON.parse(manager) : manager;

        setUser({
          id: managerData.id,
          name: `${managerData.first_name || ""} ${managerData.last_name || ""}`,
          email: managerData.email,
          role: managerData.role,
          image: managerData.image || "https://via.placeholder.com/50",
        });

        setEditForm({
          id: managerData.id,
          name: `${managerData.first_name || ""} ${managerData.last_name || ""}`,
          email: managerData.email,
          role: managerData.role,
          image: managerData.image || "https://via.placeholder.com/50",
        });
      } catch (err) {
        console.error("Invalid manager data", err);
      }
    } else {
      setUser(null);
      setEditForm(null);
    }
  }, [userData]);
  useEffect(() => {
    const interval = setInterval(() => {
      setShake(true);
      setTimeout(() => setShake(false), 400);
    }, 3000); // every 3 sec

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenUserDropdown(false);
      }
    };
    if (openUserDropdown) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openUserDropdown]);

  const handleEditSave = () => {
    setUser(editForm);
    setOpenEditModal(false);
  };

  const handleLogout = () => {
    setOpenLogoutModal(true);
    setOpenUserDropdown(false);
  };


  const confirmLogout = async () => {
    setIsLoggingOut(true);
    try {
        await logout();
      navigate("/login", { replace: true });
       localStorage.removeItem("selectedBranchId");
      // setBranch(null);
     setBranchId(null);
    } catch (err) {
      toast.error("Logout failed");
      console.error("Logout error:", err);
    } finally {
      setIsLoggingOut(false);
    }
  };

  if (isLoggingOut) {
    return <LoadingSpinner />;
  }
// console.log("selected date ",dateRange.startDate, dateRange.endDate)
  const Filter=!dateFilterSingle ? ["default","today", "yesterday","lastWeek" ,"last15", "lastMonth", "thisMonth","custom"] : ["today", "yesterday","custom"]
  const daterange = !dateFilterSingle ?"range":"single"

   return (
    <>
      <nav className=" px-0  flex justify-between  ">
        <div>
          <div>
            {branchExpireMSG && 
            <div className="  flex gap-2 px-2">
              <div>
               <div className={`border-1 border-red-600 bg-red-600 text-theme-color px-2 p-1 mt-2 rounded-1 ${shake ? "warning-vibrate" : ""}`}>
                 <IoIosWarning className={`text-theme-color text-xl `} />
               </div>
              </div>
             <div className="text-sm  flex flex-col justify-center ">
               <div className="text-sm mt-[5px] text-red-600 ">
               {t("branchExpireMSG")}
               </div>
             </div>
              </div>}
             
             {heading && !branchExpireMSG &&  <div className=" pt-[12px] px-1 font-bold text-theme-headerBg  capitalize">
                {heading ? heading : t("")}
              </div> } 
            
          </div>
        </div>
        <ul className="px-4 font-medium flex gap-3 justify-end relative top-2  ">
          <li>
            <div >
           <DateFilter
              key={`${startDate}-${endDate}`}  
              defaultDate={{ startDate:checkDate ? endDate :startDate, endDate }}
              customMode={daterange}
              availableFilters={Filter}
              onChange={(r) => {
                setStartDate(r.startDate);
                setEndDate(r.endDate);

                setDateRange({
                  startDate: r.startDate,
                  endDate: r.endDate,
                });
              }}
            />

   
         </div>

          </li>
          <li className="relative" ref={dropdownRef}>
            <div
              className="p-[5px] mt-[2px] bg-white rounded-circle cursor-pointer"
              onClick={() => setOpenUserDropdown(!openUserDropdown)}
            >
              <FaUserAlt className="" />
            </div>


            {openUserDropdown && (
              <div className="absolute right-0 mt-2 w-56 bg-white border rounded shadow-lg z-50">

                <div className="gap-3 p-3 border-b">
                  <div className="flex justify-center w-full">
                    <img
                      src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTr3jhpAFYpzxx39DRuXIYxNPXc0zI5F6IiMQ&s"
                      alt="User"
                      className="w-20 h-20 border rounded-full object-cover"
                    />
                  </div>
                  <div>
                    <div className="text-center text-theme-headerBg font-bold capitalize">
                      {user.role}
                    </div>
                    <div className="font-semibold text-center capitalize">{user.name}</div>
                    <div className="text-sm text-gray-500 text-center">
                      {user.email}
                    </div>
                  </div>
                  <FaEdit
                    className="ml-auto text-gray-500 cursor-pointer hover:text-theme-headerBg"
                    onClick={() => {
                      setOpenEditModal(true);
                      setOpenUserDropdown(false);
                    }}
                  />
                </div>
                <ul className="text-sm p-0">
                  <li
                    className="p-2 px-3 hover:bg-theme-headerBg flex justify-between items-center cursor-pointer select-none hover:text-white "
                    onClick={() => setShowLanguageMenu((prev) => !prev)}
                  >
                    <div className="flex items-center gap-2">
                      <FaLanguage /> {t('language')}
                    </div>
                    <IoIosArrowDown
                      className={`transition-transform duration-200 ${showLanguageMenu ? "rotate-180" : "rotate-0"
                        }`}
                    />
                  </li>
                  {showLanguageMenu && (
                    <div className="ps-3 pb-2 animate-fadeIn">
                      <label className="flex items-center gap-2 cursor-pointer hover:bg-theme-headerBg hover:text-white p-1 rounded-s">
                    <input
                            type="radio"
                            name="language"
                            value="en"
                            checked={selectedLanguage === "en"}
                            onChange={() => setSelectedLanguage("en")}
                            className="accent-theme-headerBg"
                          />

                        English
                      </label>
                      <label className="flex items-center gap-2 cursor-pointer hover:bg-theme-headerBg hover:text-white p-1 rounded-s">
                       <input
                              type="radio"
                              name="language"
                              value="hi"
                              checked={selectedLanguage === "hi"}
                              onChange={() => setSelectedLanguage("hi")}
                              className="accent-theme-headerBg"
                            />

                        हिंदी (Hindi)
                      </label>
                      {/* <label className="flex items-center gap-2 cursor-pointer hover:bg-theme-headerBg hover:text-white p-1 rounded-s">
                       <input
                              type="radio"
                              name="language"
                              value="pn"
                              checked={selectedLanguage === "pn"}
                              onChange={() => setSelectedLanguage("pn")}
                              className="accent-theme-headerBg"
                            />

                        ਪੰਜਾਬੀ (panjabi)
                      </label> */}
                    </div>
                  )}


                  {/* <li className="p-2 px-3 hover:bg-theme-headerBg flex items-center gap-2 cursor-pointer hover:text-white" onClick={() => {
                    navigate('/web-setting/manager')
                    setOpenUserDropdown(false);
                  }}>
                    <IoMdPersonAdd /> {t('addManager')}
                  </li> */}
                  <li
                    className="p-2 px-3 hover:bg-theme-headerBg flex items-center gap-2 cursor-pointer hover:text-white"
                    onClick={handleLogout}
                  >
                    <FaSignOutAlt /> {t('logout')}
                  </li>
                </ul>
              </div>
            )}

          </li>
        </ul>
      </nav>

     
      {openEditModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black/30 z-50">
          <div className="bg-white rounded-lg p-6 w-96 shadow-lg relative">
            <h2 className="text-lg font-semibold mb-4">Edit Profile</h2>
            <label className="block mb-2 text-sm font-medium">{t('name')}</label>
            <input
              type="text"
              value={editForm.name}
              onChange={(e) => setEditForm({ ...editForm, name: e.target.value })}
              className="border rounded w-full p-2 mb-3"
            />
            <label className="block mb-2 text-sm font-medium">{t('email')}</label>
            <input
              type="email"
              value={editForm.email}
              onChange={(e) => setEditForm({ ...editForm, email: e.target.value })}
              className="border rounded w-full p-2 mb-3"
            />
            <label className="block mb-2 text-sm font-medium">{t('profileImage')}</label>
            <input
              type="text"
              value={editForm.image}
              onChange={(e) => setEditForm({ ...editForm, image: e.target.value })}
              className="border rounded w-full p-2 mb-4"
            />

            <div className="flex justify-end gap-3">
     
              <CancelButton onClick={() => setOpenEditModal(false)} text={t('cancel')} />
    
              <SaveButton  onClick={handleEditSave} text={t('save')}/>
            </div>
          </div>
        </div>
      )}

      {openLogoutModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black/30 z-[1000]">
          <div className="bg-white rounded-lg p-2 w-96 shadow-lg relative text-center">
            <div className=" font-semibold bg-theme-headerBg text-theme-color py-[4px] rounded-1 mb-2">
             {t('logoutConfirm')}
            </div>
            <img
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTr3jhpAFYpzxx39DRuXIYxNPXc0zI5F6IiMQ&s"
              alt="User"
              className="w-16 h-16 rounded-full mx-auto mb-1 border"
            />
            <div className="mb-1 text-theme-headerBg font-medium capitalize" >{user.role}</div>
            <div className="text-gray-600  fw-bold capitalize">{user.name}</div>
            <div className="text-gray-500 text-sm mb-4">{user.email}</div>

            <div className="flex justify-center gap-2 mb-2">
          
              <CancelButton onClick={()=>setOpenLogoutModal(false)} text={t('cancel')} />
              <SaveButton onClick={confirmLogout} text={t('logout')} />
            </div>
          </div>
        </div>
      )}
    </>
  );
} 